module.exports = __webpack_public_path__ + "static/voice3-d58f58e8051c215077ba31cfceb3dc1c.webp";